export const DEFAULT_OVERVIEW_IMAGE_WIDTH = 800;

export const DEFAULT_OVERVIEW_IMAGE_HEIGHT = 500;

export const DEFAULT_OVERVIEW_IMAGE_SIZE = {
  width: DEFAULT_OVERVIEW_IMAGE_WIDTH,
  height: DEFAULT_OVERVIEW_IMAGE_HEIGHT,
  sizeFactor: 1,
};
